import React, { useCallback, useEffect, useState } from 'react';
import {
  SW_UPDATE_PENDING_EVENT,
  activateWaitingServiceWorker,
  reloadForServiceWorkerUpdate,
} from '../pwa/pwaServiceWorkerUpdates';
import './pwa-install.css';

/**
 * Shown when a new build is ready but we deferred auto-reload (e.g. checkout).
 * Also appears briefly on standalone launches before reload completes.
 */
export default function PwaUpdateBanner() {
  const [registration, setRegistration] = useState(null);
  const [visible, setVisible] = useState(false);

  const applyUpdate = useCallback(() => {
    if (!registration) {
      reloadForServiceWorkerUpdate();
      return;
    }
    const activated = activateWaitingServiceWorker(registration);
    if (!activated) {
      reloadForServiceWorkerUpdate();
    }
  }, [registration]);

  useEffect(() => {
    const onPending = () => {
      navigator.serviceWorker.ready
        .then((reg) => {
          setRegistration(reg);
          setVisible(true);
        })
        .catch(() => setVisible(true));
    };

    window.addEventListener(SW_UPDATE_PENDING_EVENT, onPending);
    return () => window.removeEventListener(SW_UPDATE_PENDING_EVENT, onPending);
  }, []);

  if (!visible) return null;

  return (
    <div className="pwa-update-banner" role="status" aria-live="polite">
      <div className="pwa-update-banner__copy">
        <p className="pwa-update-banner__title">Update available</p>
        <p className="pwa-update-banner__desc">Refresh to get the latest shop experience.</p>
      </div>
      <button type="button" className="btn btn-sm btn-primary rounded-pill pwa-update-banner__btn" onClick={applyUpdate}>
        Refresh
      </button>
    </div>
  );
}
